import { APP_ROUTES } from "@src/constants";

type EntryRoutePath =
  | typeof APP_ROUTES.GET_STARTED
  | typeof APP_ROUTES.REFER
  | typeof APP_ROUTES.MEET_THE_TEAM;

export type EntryRouteIdentityPolicy = "ensure" | "reset-session" | "regenerate-uuid";

// Canonical list of entry routes used to identify flow start pages.
export const ENTRY_ROUTES = [
  {
    name: "get-started",
    path: APP_ROUTES.GET_STARTED,
    identityPolicy: "ensure",
  },
  {
    name: "refer",
    path: APP_ROUTES.REFER,
    identityPolicy: "reset-session",
  },
  {
    name: "meet-the-team",
    path: APP_ROUTES.MEET_THE_TEAM,
    identityPolicy: "regenerate-uuid",
  },
] as const satisfies ReadonlyArray<{
  name: string;
  path: EntryRoutePath;
  identityPolicy: EntryRouteIdentityPolicy;
}>;

export type EntryRouteDefinition = (typeof ENTRY_ROUTES)[number];

export const ENTRY_ROUTE_PATHS = ENTRY_ROUTES.map((route) => route.path);

export const isRegisteredEntryRoutePath = (pathname: string): boolean => {
  return ENTRY_ROUTE_PATHS.some((path) => {
    if (pathname === path) {
      return true;
    }

    // Preserve existing behavior where only /refer accepts descendant paths.
    if (path === APP_ROUTES.REFER) {
      return pathname.startsWith(`${path}/`);
    }

    return false;
  });
};

export const getEntryRouteDefinition = (pathname: string): EntryRouteDefinition | undefined =>
  ENTRY_ROUTES.find((route) => {
    if (pathname === route.path) return true;
    return route.path === APP_ROUTES.REFER && pathname.startsWith(`${route.path}/`);
  });
